/*
 * Public API Surface of Tags Component
 */

export * from './tags.module';
export * from './components/tag/tag.component';
export * from './components/tags/tags.component';
export * from './interfaces/tag.interface';
